<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap"> {{ getText(processConfig?.globalizationConfig, 'title') | uppercase }} </ion-label>
        </ion-item>

        <app-step-description
            [description]="getText( processConfig?.globalizationConfig, 'instructions' )"
            [employee]="{
                                imageUrl: getImageUrl(user?.imageUrl),
                                username: user?.name,
                                lineManager: user?.lineManager
                            }"
            [extraDescription]="'freeEvaluationMidYear.formFill' | translate"
        ></app-step-description>

        <form [formGroup]="formGroup" *ngIf="formGroup">
            <ng-container *ngFor="let group of processConfig.questionsGroups | questionGroupAttributes: user?.attributes; let groupIndex = index">
                <ng-container *ngIf="(group.hasCalculateQuestions && !questionsType[QuestionType.Calculate].hidden) || !group.hasCalculateQuestions">
                    <h4>{{ (groupIndex + 1) + ' - ' + getText(group.globalizationConfig, 'title') }}</h4>
                </ng-container>
                <app-question-types *ngFor="let question of group.questions" [question]="question" [formGroup]="formGroup"></app-question-types>
            </ng-container>
            <app-question-types *ngFor="let question of processConfig.questions" [question]="question" [formGroup]="formGroup"></app-question-types>
        </form>

        <ng-container *ngIf="!editingEvaluation || editingEvaluation.status === FreeEvaluationStatus.NotSent">
            <div class="bottom-buttons" text-right>
                <ion-button mode="ios" color="primary" class="save" (click)="saveEvaluation(formGroup)"> {{ 'generic.save' | translate }} </ion-button>
            </div>
        </ng-container>
    </div>
</ion-content>
